export enum PagesOfAddUserToOneSelectedAccount {
    STEPPER = 'stepper',
    UNSUCCESSFUL_ATTEMPT = 'unsuccessful_attempt',
}
